const ROUTES = {
    //SITEMAP
    homeRoute: () => "/",
    //NOINDEX
    missingRoute: () => "/404"
};

export default ROUTES;